window.Tokens = {
	specialTokens: ["[PROJECT_NAME]", "[REPORT_NAME]", "[SLIDE_NAME]", "[SLIDE_NO]", "[DATE]"],

	hideNoSelectionTokens: true,
	isSpecialToken : function(value) {
		for (var i = 0; i < Tokens.specialTokens.length; i++)
			if (("[" + value + "]") == Tokens.specialTokens[i])
				return true;

		return false;
	},
	getMatchingSpecialToken : function(value) {
		for (var i = 0; i < Tokens.specialTokens.length; i++)
			if (value.match(new RegExp(Tokens.specialTokens[i].replace('[', '\\[').replace(']', '\\]')), "g"))
				return Tokens.specialTokens[i];

		return null;
	},
	getUsedTokens: function (layoutElementItem, tokenPattern) {
		function getTextNodes(element) {
			var textNodes = [];

			if (element.childNodes.length > 0)
				for (var i = 0; i < element.childNodes.length; i++)
					textNodes = $.merge(textNodes, getTextNodes(element.childNodes[i]));

			if (element.nodeType === 3)
				textNodes.push(element);

			return textNodes;
		}

		var hfmatches = [];
		$(getTextNodes($("#" + layoutElementItem.guid)[0])).each(function () {
			$(this.nodeValue.match(tokenPattern)).each(function () {
				hfmatches.push(this);
			});
		});

		return hfmatches;
	},
	getUsedHFilterTokens: function (layoutElementItem) {
		return Tokens.getUsedTokens(layoutElementItem, new RegExp("\\[HFILTER:[LO][:\\d]*\\]", "g"));
	},
	getUsedQuestionTokens: function (layoutElementItem) {
		return Tokens.getUsedTokens(layoutElementItem, new RegExp("\\[.+?:[CT]\\]", "g"));
	},

	setTokenValue: function (tokens, token, value) {
		var existingToken = null;
		for (var i = 0; i < tokens.length; i++)
			if (token == tokens[i].Token) {
				existingToken = tokens[i];
			}

		if (existingToken != null)
			existingToken.Value = value;
		else
			tokens.push({ Token: token, Value: value });
	},
	replaceSlideTokensInDummyBg: function(dummyBg, tokens, slideNo, slideName) {
		var bgSlide = Storyboard.LayoutDesigner.getBackgroundSlide();
		if (!bgSlide) return;

		tokens = tokens || [];

		Tokens.setTokenValue(tokens, "SLIDE_NAME", slideName || "");
		Tokens.setTokenValue(tokens, "SLIDE_NO", slideNo || "");

		dummyBg.find('.layoutElementStaticText').each(function(index, element) {
			Tokens.replaceTokensInDOM($(element), tokens);
		});
	},
	replaceTokensOnSlide: function (slide, tokens) {
		if (slide == null || !tokens) return;
		var slideElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(slide);

		var itemTypes = Storyboard.Constants.itemTypes;
		slideElements.forEach(function (layoutElement) {
			var htmlElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.STATICTEXT, layoutElement);

			if (htmlElem && htmlElem.content) {
				var tokensPattern = new RegExp("([\\[](Q[0-9]+|INT|TP|MA|VS|RD|HFILTER)[:][LO][:\\d:]*[\\]])");
				var questionTokenPattern = new RegExp("\\[.+?:[CT]\\]");
				if (tokensPattern.test(htmlElem.content) || questionTokenPattern.test(htmlElem.content) || Tokens.getMatchingSpecialToken(htmlElem.content) != null) {
					Tokens.replaceTokensInLayoutElementItem(htmlElem, tokens);
				}
			}
		});
	},
	replaceTokensInLayoutElementItem: function (layoutElementItem, tokens) {
		if (!window.IsFormReport) {
			var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem));
			if (slide.isBackground)
				slide = Storyboard.LayoutDesigner.getCurrentSlide();

			Tokens.setTokenValue(tokens, "SLIDE_NAME", (window.IsMyStories ? slide.sourceSlideName : slide.slideName) || "");
			Tokens.setTokenValue(tokens, "SLIDE_NO", window.IsMyStories ? slide.sourceSlideIndex : slide.slideIndexIncluded ? slide.slideIndexIncluded : slide.slideIndex);
		}

		var layoutElementItemDiv = $('#' + layoutElementItem.guid);
		var domRepr = $(layoutElementItem.content || '');

		layoutElementItemDiv.html(Tokens.replaceTokensInDOM(domRepr, tokens));
	},
	replaceTokensInDOM(domRepr, tokens) {
		$(domRepr).find('.hidToken').each(function () {
			var textNode = $(this).contents();
			textNode.insertBefore($(this));
			$(this).next('.tokenValue').remove();
		});
		$(domRepr).find('.hidToken').remove();
		$(domRepr).find('p').show();

		function getTextNodes(element) {
			var textNodes = [];

			if (element.childNodes.length > 0)
				for (var i = 0; i < element.childNodes.length; i++)
					textNodes = $.merge(textNodes, getTextNodes(element.childNodes[i]));

			if (element.nodeType === 3)
				textNodes.push(element);

			return textNodes;
		}

		var textNodes = getTextNodes(domRepr[0]);

		$(tokens).each(function () {
			var specialToken = Tokens.isSpecialToken(this.Token);

			var tokenPatternT = "\\[" + this.Token;
			if (specialToken)
				tokenPatternT += "\\]";
			else if (this.IsQuestionToken)
				tokenPatternT += "[:][CT]\\]";
			else
				tokenPatternT += "[:][LO][\\d:]*\\]";

			var tokenPattern = new RegExp(tokenPatternT, this.IsQuestionToken ? "gi" : "g");
			var token = this;

			$(textNodes).filter(function () {
				return this.nodeValue.match(tokenPattern);
			}).each(function () {
				if (!$(this).parent().hasClass("tokenValue"))
					$(this).wrap("<span class='tokenValue'></span>");
				var tokenValueSpan = $(this).parent();

				if ($(this).parent().prev(".hidToken").length < 1) {
					var hiddenToken = tokenValueSpan.contents().clone();
					hiddenToken.insertBefore(tokenValueSpan);
					hiddenToken.wrap("<span class='hidToken' style='display:none'></span>");
				}

				if (specialToken) {
					this.nodeValue = this.nodeValue.replace("[" + token.Token + "]", token.Value);
				}

				if (token.IsQuestionToken) {
					this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":C\\]", "gi"), token.Token);
					this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":T\\]", "gi"), token.Value);
				}
				else {
					if (token.Value == "-1") // No Selection
					{
						if (Tokens.hideNoSelectionTokens || token.NoAccess) {
							$(this).closest("p").find("br").remove();
							var commaIndex = -1;
							if (this.nodeValue.indexOf(", [" + token.Token + ":L]") > -1)
								commaIndex = this.nodeValue.indexOf(", [" + token.Token + ":L]");
							else if (this.nodeValue.indexOf(", [" + token.Token + ":O]") > -1)
								commaIndex = this.nodeValue.indexOf(", [" + token.Token + ":O]");
							else if (this.nodeValue.indexOf("[" + token.Token + ":O], ") > -1)
								commaIndex = this.nodeValue.indexOf("[" + token.Token + ":O], ") + ("[" + token.Token + ":O]").length;

							if (commaIndex > -1)
								this.nodeValue = this.nodeValue.substr(0, commaIndex) + this.nodeValue.substr(commaIndex + 2);

							this.nodeValue = this.nodeValue.replace("[" + token.Token + ":L]: ", "");
							this.nodeValue = this.nodeValue.replace("[" + token.Token + ":L]", "");
							this.nodeValue = this.nodeValue.replace("[" + token.Token + ":O]", "");
							return;
						}

						this.nodeValue = this.nodeValue.replace("[" + token.Token + ":O]", "" + Storyboard.GeneralSettings.filterNoSelectionLabel + "");
					}
					else if (token.Token == "HFILTER" && token.HFilterFormat) {
						if (token.Value.indexOf('$0') > -1) {
							token.Value = token.Value.replace('$', '$$$');
						}
						var hfSuffix = token.HFilterFormat + (token.HFilterFormat == 3 ? ":" + token.HFilterLevels : "");
						this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":O:" + hfSuffix + "\\]", "g"), token.Value);
						this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":O\\]", "g"), token.Value);
					}
					else {
						this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":O\\]", "g"), token.Value);
					}
					this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":L\\]", "g"), token.Label);
				}
			});
		});

		var missinFilterTokensPattern = new RegExp("([\\[](Q[0-9]+)[:][LO][:\\d:]*[\\]])");
		$(textNodes).filter(function () {
			return this.nodeValue.match(missinFilterTokensPattern);
		}).each(function () {
			if ($(this).parent().prev(".hidToken").length < 1) {
				$(this).before("<span class='hidToken' style='display:none'></span>");
			}
		});

		return domRepr;
	},
	replaceTokens: function (layoutElementItem) {
		function getTextNodes(element) {
			var textNodes = [];

			if (element.childNodes.length > 0)
				for (var i = 0; i < element.childNodes.length; i++)
					textNodes = $.merge(textNodes, getTextNodes(element.childNodes[i]));

			if (element.nodeType === 3)
				textNodes.push(element);

			return textNodes;
		}

		var hfilterValTokenPattern = new RegExp("\\[HFILTER:[LO][:\\d]*\\]", "g");
		var hfDomrepr = $("#" + layoutElementItem.guid);
		var hftextNodes = getTextNodes(hfDomrepr[0]);
		var hfmatches = [];
		$(hftextNodes).each(function () {
			$(this.nodeValue.match(hfilterValTokenPattern)).each(function () {
				hfmatches.push(this);
			});
		});

		Helpers.perfJSonCall({
			method: 'GetAvailableTokensList',
			data: { settings: GeneralSettings.getSelectedSettings(), hFilterTokens: hfmatches, questionTokens: null },
			successCallback: function (tokens) {
				var regExpPattern1 = "\\[";
				var regExpPattern2 = "[:][LO][\\d:]*\\]";
				var domRepr = $("#" + layoutElementItem.guid);

				$(domRepr).find('.hidToken').each(function () {
					var textNode = $(this).contents();
					textNode.insertBefore($(this));
				});
				$(domRepr).find('.hidToken').remove();
				$(domRepr).find('.tokenValue').remove();

				var textNodes = getTextNodes(domRepr[0]);

				$(tokens).each(function () {
					var tokenPattern = new RegExp(regExpPattern1 + this.Token + regExpPattern2, "g");
					var token = this;

					$(textNodes).filter(function () {
						return this.nodeValue.match(tokenPattern);
					}).each(function () {
						$(this).wrap("<span class='tokenValue'></span>");
						var tokenValueSpan = $(this).parent();

						var hiddenToken = tokenValueSpan.contents().clone();
						hiddenToken.insertBefore(tokenValueSpan);
						hiddenToken.wrap("<span class='hidToken' style='display:none'></span>");

						this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":L\\]","g"), token.Label);
						if (token.Value == "-1") // No Selection
						{
							this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":O\\]", "g"), "" + Storyboard.GeneralSettings.filterNoSelectionLabel + "");
						}
						else if (token.Token == "HFILTER" && token.HFilterFormat) {
							var hfSuffix = token.HFilterFormat + (token.HFilterFormat == 3 ? ":" + token.HFilterLevels : "");
							this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":O:" + hfSuffix + "\\]", "g"), token.Value);
							this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":O\\]", "g"), token.Value);
						}
						else {
							this.nodeValue = this.nodeValue.replace(new RegExp("\\[" + token.Token + ":O\\]","g"), token.Value);
						}
					});
				});
			}
		});
	}
};
